@if (item.sectionHeader && !isCollapsed && level === 0) {
<div class="nav-section-header">
    <span>{{ item.sectionHeader }}</span>
</div>
}

<!-- Navigation Item -->
<mat-list-item class="nav-item" [class.active]="isActive(item)" [class.has-active-child]="hasActiveChild(item)" [class.disabled]="item.disabled"
    [class.has-children]="item.children && item.children.length > 0" [class.child-item]="level > 0"
    (click)="onItemClick(item, $event)" [matTooltip]="isCollapsed ? item.label : ''" matTooltipPosition="right"
    matTooltipClass="nav-tooltip">

    @if (item.icon) {
    <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
    }

    @if (!isCollapsed) {
    <div class="label-container" matListItemTitle>
        <span class="item-label">
            {{ item.label }}
        </span>
        <!-- Expand/Collapse icon for parent items with children -->
        @if (!isHandset && item.children && item.children.length > 0) {
        <mat-icon class="expand-icon" [class.expanded]="item.expanded">
            {{ item.expanded ? 'expand_less' : 'expand_more' }}
        </mat-icon>
        }
    </div>
    }

    @if (item.badge && (!isCollapsed)) {
    <span matListItemLine class="item-badge">
        {{ item.badge }}
    </span>
    }

    <!-- Badge for collapsed state -->
    @if (item.badge && isCollapsed && !isHandset) {
    <div class="collapsed-badge">
        {{ item.badge }}
    </div>
    }
</mat-list-item>

<!-- Recursive Children -->
@if (item.children && item.children.length > 0 && item.expanded && (!isCollapsed || isHandset)) {
<div class="child-items-container">
    @for (child of item.children; track child.id) {
    <lib-vertical-nav-item [item]="child" [isCollapsed]="isCollapsed" [level]="level + 1" [isHandset]="isHandset">
    </lib-vertical-nav-item>
    }
</div>
}